import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import PropTypes from 'prop-types'
import { isValidEmail } from '../../../../Helpers/isValidEmail.js'
import AuthForm from '../AuthForm'
import TextField from '../../../../Components/GeneralComponents/TextField'
import errorToast from '../../../../Components/Toasts/ErrorToast.jsx'
import { ButtonOutline } from '../../../../Components/GeneralComponents/ButtonOutline/ButtonOutline.jsx'
import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from 'firebase/auth'
import { app_sso } from '../../../../firebase.js'

const SetUpEmailForm = ({ handleSetUpContinue }) => {
  const searchParams = new URLSearchParams(window.location.search)
  const encodedEmail = searchParams.get('ou')

  const decodedEmail = encodedEmail ? atob(encodedEmail) : ''
  const [email, setEmail] = useState(decodedEmail)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const isEmailValid = () => isValidEmail(email)

  const checkForValidEmail = async () => {
    if (!isEmailValid()) {
      errorToast('Email has invalid format')
    }

    const auth = getAuth(app_sso)
    const url = window.location.href
    if (!isSignInWithEmailLink(auth, url)) {
      errorToast('Your invitation link is not valid or expired')
      navigate('/login')
      return
    }

    try {
      const { user } = await signInWithEmailLink(auth, email, url)
      handleSetUpContinue(user)
    } catch (err) {
      errorToast("You haven't been invited or invite link has expired")
      navigate('/login')
    }
  }

  useEffect(() => {
    if (!encodedEmail) {
      errorToast('Missing email in the invitation link')
      navigate('/login', { replace: true })
    }
  }, [encodedEmail])

  const handleSubmit = async event => {
    event.preventDefault()
    setIsLoading(true)
    await checkForValidEmail()
    setIsLoading(false)
  }

  return (
    <AuthForm title={'Set Up Account'} onSubmit={handleSubmit}>
      <TextField
        label={'Email'}
        placeholder={'Enter email'}
        onChange={e => setEmail(e.target.value)}
        value={email}
        name="email"
        id="email"
      />
      <ButtonOutline
        type="submit"
        color="pink"
        text="Continue"
        disable={!isEmailValid() || isLoading}
      />
    </AuthForm>
  )
}

SetUpEmailForm.propTypes = {
  handleSetUpContinue: PropTypes.func,
}

export default SetUpEmailForm
